export enum SITE {
  CS = "cs",
}

export const SITE_SUBJECT = ISAAC_SITE as SITE;

export const SITE_SUBJECT_TITLE = "Computer Science";

export const WEBMASTER_EMAIL = "webmaster@isaaccomputerscience.org";

export const TEACHER_REQUEST_ROUTE = "/pages/teacher_accounts";
